// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.excalidraw-wrapper .layer-ui__wrapper,
.excalidraw-wrapper .FixedSideContainer.FixedSideContainer_side_top.App-top-bar,
.excalidraw-wrapper .App-bottom-bar {
  visibility: hidden !important;
  pointer-events: none !important;
  position: absolute !important;
  width: 0 !important;
  height: 0 !important;
  overflow: hidden !important;
}
`, "",{"version":3,"sources":["webpack://./react/features/whiteboard/style.css"],"names":[],"mappings":"AAAA;;;EAGE,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;AAC7B","sourcesContent":[".excalidraw-wrapper .layer-ui__wrapper,\n.excalidraw-wrapper .FixedSideContainer.FixedSideContainer_side_top.App-top-bar,\n.excalidraw-wrapper .App-bottom-bar {\n  visibility: hidden !important;\n  pointer-events: none !important;\n  position: absolute !important;\n  width: 0 !important;\n  height: 0 !important;\n  overflow: hidden !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
